import { CircleX } from 'lucide-react';
function CloseMapControl({ className, onClick }: { className: string, onClick: () => void }) {

  return (
    <div className={className}>
      <div className="leaflet-control leaflet-bar">
        <button
          onClick={onClick}
          className="absolute top-[-4px] right-[-4px] text-white text-2xl z-10 hover:opacity-75 w-8 h-8 rounded-full flex items-center justify-center cursor-pointer"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
        >
          <CircleX className="w-8 h-8" />
        </button>
      </div>
    </div>
  );
}

export default CloseMapControl;
